import Vue from "vue";
import axios from "axios";
import router from "../router";
import { API_URL, API_URLDEV, COOKIE_TIMEOUT } from "./config";
import Observable from "./observable";
import Localbase from "localbase";
import JwtService from "./jwtservices";
import state from "../stores/index";
// json
import versions from "../assets/json/versions.json";

const ApiService = {
  loadObserver: new Observable(),
  loginObserver: new Observable(),
  errorObserver: new Observable(),
  notifyObserver: new Observable(),
  homepageObserver: new Observable(),
  localDB: new Localbase("dbSolucoes"),
  
  init() {
    if (process.env.NODE_ENV === 'development') {
      axios.defaults.baseURL = API_URLDEV;
    } else {
      axios.defaults.baseURL = API_URL;
    }
    this.setBasicHeader();
    this.localDB.config.debug = false;
  },

  // async getLocalDBDocument(key, collection = localStorage.getItem("lastlogin") || 'anonimous') {
  async getLocalDBDocument(key, collection = JwtService.getUser() || 'anonimous') {

    // console.log('JwtService.getUser():', JwtService.getUser());
    // console.log('JwtService.getToken():', JwtService.getToken());
    // console.log('JwtService.parsePayload():', JwtService.parsePayload());
      
    return await this.localDB
      .collection(collection)
      .doc(key)
      .get()

  },

  // async setLocalDBDocument(data, key, collection = localStorage.getItem("lastlogin") || 'anonimous') {
  async setLocalDBDocument(data, key, collection = JwtService.getUser() || 'anonimous') {

    if (key) {
      await this.localDB.collection(collection).doc(key).get().then(document => {
        // console.log(document);
        if (document) {
          // console.log('setLocalDBDocument:', key, 'exists');
          this.localDB.collection(collection).doc(key).update(data)
        }
        else {
          // console.log('setLocalDBDocument:', key, 'not exists');
          this.localDB.collection(collection).add(data, key)
        };
      })
    } else {
      await this.localDB.collection(collection).add(data);
    }

  },

  async delLocalDBDocument(collection, key) {

    await this.localDB.collection(collection).doc(key).delete();

  },

  setlocalDB(vueobject) {
    // console.log('setlocalDB.name:', vueobject.$options.name);
    // console.log('setlocalDB.data:', vueobject.$data);
    ApiService.setLocalDBDocument(
        { data: vueobject.$data },
        vueobject.$options.name
      );
  },

  getlocalDB(vueobject) {
    return ApiService.getLocalDBDocument(vueobject.$options.name);
  },

  setBasicHeader() {
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers.common["Access-Control-Allow-Methods"] =
      "GET, POST, PUT, DELETE";
    axios.defaults.headers.common["Access-Control-Allow-Headers"] =
      "Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type";
    axios.defaults.headers.common["Content-Type"] = "application/json";
    axios.defaults.headers.common["Accept"] = "application/json";
    axios.defaults.headers.common["Autor"] = '{nome: "Marcelo Horlle", email: "joehor@gmail.com"}';
    axios.defaults.headers.common["Doloading"] = true;
    axios.defaults.headers.common["X-App-Name"] = "Portal Soluções";
    axios.defaults.headers.common["X-App-Version"] = versions[versions.length-1].version;
  },

  get(resource, params = {}, loading = true) {
    if (!params.params) {
      params = { params: params };
    }
    params = { ...params, ...{ timeout: 15000 } };
    try {
      if (!axios.defaults.headers.Authorization || axios.defaults.headers.Authorization == "") {
        const token = Vue.$cookies.get("token");
        if (token && token !== "") axios.defaults.headers.Authorization = `Bearer ${token}`;
      }

      axios.defaults.headers["Doloading"] = loading;
      return Vue.axios.get(resource, params);
    } catch (error) {
      // console.log("get::error: ", error);
      throw new Error(`[RWV] ApiService ${error}`);
    }
  },

  post(resource, params = {}, loading = true) {
    try {
      if (!axios.defaults.headers.Authorization || axios.defaults.headers.Authorization == "") {
        const token = Vue.$cookies.get("token");
        if (token && token !== "") axios.defaults.headers.Authorization = `Bearer ${token}`;
      }

      axios.defaults.headers["Doloading"] = loading;
      return Vue.axios.post(resource, params);
    } catch (error) {
      // console.log("post::error: ", error);
      throw new Error(`[RWV] ApiService ${error}`);
    }
  },

  update(resource, params) {
    try {
      return axios.put(resource, params);
    } catch (error) {
      // console.log("update::error: ", error);
      throw new Error(`[RWV] ApiService ${error}`);
    }
  },

  put(resource, params) {
    try {
      return axios.put(`${resource}`, params);
    } catch (error) {
      // console.log("put::error: ", error);
      throw new Error(`[RWV] ApiService ${error}`);
    }
  },

  delete(resource) {
    try {
      return axios.delete(resource);
    } catch (error) {
      // console.log("delete::error: ", error);
      throw new Error(`[RWV] ApiService ${error}`);
    }
  },

  setloading(loading) {
    axios.defaults.headers["Doloading"] = loading;
  },

  prepareData(response) {
    // console.log("ApiService.prepareData.response]:", response);
    let data = {
      busy: false,
      apiresponse: response,
      success: (response && (response.Success || response.Success == "True") || (response.data && (response.data.Success || response.data.Success == "True"))) ? true : false,
      error: (response && response.Error) || (response.data && response.data.Error) || (response && response.Message) || "",
      data: (response && response.Data) || (response.data && response.data.Data) || [],
      updated: new Date()
    };
    // console.log("ApiService.data:", data);
    return data;
  },

  logout() {
    // console.log('apiservice.Emitiu logout');
    sessionStorage.setItem("token", "");
    Vue.$cookies.set("token", "");
    Vue.$cookies.set("loginexpires", "");
    this.loginObserver.notify(false);
  },

  sethomepage(route) {
    this.setLocalDBDocument({route: route.fullPath, name: route.name}, "homepage");
    this.homepageObserver.notify({route: route.fullPath, name: route.name});
    if (typeof (route) == 'string') route = { value: route, name: route };
    if (typeof (route) == 'number') route = { value: route, name: route };
    this.SetLoginData('homepage', route);
  },

  gethomepage() {
    // console.log('gethomepage:', this.GetLoginData('homepage'));
    // console.log('gethomepage.homepage:', ((this.GetLoginData('homepage') && this.GetLoginData('homepage').data && this.GetLoginData('homepage').data.homepage) || {value: "/"}).value);
    // return ((this.GetLoginData('homepage') && this.GetLoginData('homepage').data && this.GetLoginData('homepage').data.homepage) || {value: "/"}).value;
    this.getLocalDBDocument("homepage").then((doc) => {
      // console.log('gethomepage:', doc);
      if (doc) {
        return doc.route
      } else {
        return "/"
      }
    })
  },

  SetLoginData(tag, data) {
    const login = Vue.$cookies.get("login") || 'anonimous';
    let store = this.GetLoginData(tag);
    store.data = {};
    store.data[tag] = data;
    // console.log('loginDtaSet:store:', JSON.stringify(store));
    localStorage.setItem(login, JSON.stringify(store));
    // console.log('SetPageData.store:', store);
    return store;
  },

  GetLoginData(tag) {
    const login = Vue.$cookies.get("login") || 'anonimous';
    let store = localStorage.getItem(login);
    if (!store)
      store = JSON.stringify({ data: { [tag]: {} } });
    return JSON.parse(store);
  },

  SetPageData(pagename, data) {
    let store = {};
    if (pagename) {
      const login = Vue.$cookies.get("login") || 'anonimous';
      store = this.GetPageData(pagename);
  
      if (!store)
        store = JSON.stringify({ pages: { [pagename]: {} } })
      else
        store.pages[pagename] = data;
      
      localStorage.setItem(login, JSON.stringify(store));
      // console.log('SetPageData.store:', store);
    } else {
      // console.log('ApiServices.SetPageData:página não informada', data);
    }

    return store;
  },

  GetPageData(pagename) {
    const login = Vue.$cookies.get("login") || 'anonimous';
    let store = localStorage.getItem(login);
    if (!store)
      store = JSON.stringify({ pages: { [pagename]: {} } });
    return JSON.parse(store);
  },

  renewLogin() {
    return new Promise((res, rej) => {
      let token = {
        token: Vue.$cookies.get("token")
      };
      Vue.axios.post('Servicos/Renova/Token', token, false).then((apidata) => {
        const data = ApiService.prepareData(apidata);
        if (data.success) {
          token = data.data[0].token;
          Vue.$cookies.set("token", token, COOKIE_TIMEOUT);
          Vue.$cookies.set("loginexpires", new Date().setMinutes(new Date().getMinutes() + 20), { expires: COOKIE_TIMEOUT });
          sessionStorage.setItem("token", token);

          res(apidata);
        } else {
          rej(apidata);
        }
      })
        .catch((err) => {
        rej(err)
      })
    }
    );
  }

};

// inicia as configurações ...
ApiService.init();

// INICIO - Interceptors
axios.interceptors.request.use(
  async (config) => {
    /* console.log("interceptor.request.config", config);
    console.log(
      "config.url.includes(Authentication)",
      config.url.includes("Authentication")
    ); */

    if (!config.url.includes("Authentication")) {
      const token = Vue.$cookies.get("token");
      // token autenticado
      if (token && token !== "") {
        config.headers.Authorization = `Bearer ${token}`;
        const login = Vue.$cookies.get("login");
        if (login && login !== "") {
          // renova para mais 20 min
          Vue.$cookies.set("login", login, { expires: COOKIE_TIMEOUT });
          Vue.$cookies.set("loginexpires", new Date().setMinutes(new Date().getMinutes() + 20), { expires: COOKIE_TIMEOUT });
          Vue.prototype.$userLogged = login || "";
        }

      } else {
        const anontoken = Vue.$cookies.get("anontoken");
        if (anontoken && anontoken !=="") {
          config.headers.Authorization = `Bearer ${anontoken}`;
        }
      }
    }

    // console.log('ApiService.intercept.request.loading:', config.headers["Doloading"]);
    if (config.headers["Doloading"]) {
      ApiService.loadObserver.notify(true);
    };

    return config;
  },
  (error) => {
    // console.log('ApiService.intercept.request.loading:', config.headers["Doloading"]);
    if (config.headers["Doloading"]) {
      ApiService.loadObserver.notify(false);
    };
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res) => {
    const notifications = {
      variant: "success",
      message: "",
    };

    //ApiService.loadObserver.notify(false);
    //return res;

    // salva a chamada na lista para bloquear a chamada caso ocorra algum erro ...
    state.dispatch('actEndpointRequests', { url: res.config.url, status: res.status });

    // console.log('apiservice.interception.url:', res.config.url);
    if (res.config.url == "Authentication") {
      const user = JSON.parse(res.config.data);
      // console.log('apiservices.interception.user:', user);
      const isAuth = (res.data.TokenAccess || "") !== "";
      if (isAuth) {
        res.config.headers.Authorization = `Bearer: ${res.data.TokenAccess}`;
        Vue.$cookies.set("token", res.data.TokenAccess, COOKIE_TIMEOUT);
        Vue.$cookies.set("loginexpires", new Date().setMinutes(new Date().getMinutes() + 20), { expires: COOKIE_TIMEOUT });

        const value = "seuValor";
        const expires = new Date(new Date().getTime() + 60 * 60 * 1000); // 1 hora a partir de agora
        Vue.$cookies.set('meuCookie', JSON.stringify({ value, expires }), '1h');

        localStorage.setItem("lastlogin", user.User);
        sessionStorage.setItem("token", res.data.TokenAccess);
        notifications.message = "Autenticado com sucesso!";
        notifications.variant = "success";
        ApiService.notifyObserver.notify(notifications);
        // console.log(user.User, "autenticado com sucesso!");
        ApiService.loginObserver.notify(isAuth);
      }
    }

    const token = Vue.$cookies.get("token");
    if (token && token !== "") {
      Vue.$cookies.set("token", token, COOKIE_TIMEOUT);
      Vue.$cookies.set("loginexpires", new Date().setMinutes(new Date().getMinutes() + 20), { expires: COOKIE_TIMEOUT });
        sessionStorage.setItem("token", token);
    }


    if (res.config.url === "Authentication/GetAnonymousToken") {
      axios.defaults.headers.common.Authorization = `Bearer: ${res.data.TokenAccess}`;
      Vue.$cookies.set("anontoken", res.data.TokenAccess, { expires: "1D" });
      sessionStorage.setItem("anontoken", res.data.TokenAccess);
      // console.log("Anonymous", "autenticado com sucesso!");
    }

    // isso testa as duas APIs a Normal e a v2
    if (res.data.Success === "False" || res.data.Success === false) {
      notifications.variant = "danger";
      notifications.message = res.data.Error;
      ApiService.notifyObserver.notify(notifications);
    }

    // console.log('ApiService.intercept.response.loading:', res.config.headers["Doloading"]);
    if (res.config.headers["Doloading"]) {
      ApiService.loadObserver.notify(false);
    };
    return res;
  },
  (err) => {
    // console.log("ApiService.error.router.history.current:",router.history.current);
    // console.log("err:", err);
    // console.log("err.response:", err.response);
    // console.log("err.response.status:", err.response.status);
    const error = {
      error: err,
      response: null,
      route: router.currentRoute,
      status: 0,
      data: null,
      headers: null,
      message: null,
      variant: "",
      timestamp: new Date()
    };

    if (err.response.data.Success == false && err.response.data.Message !== '') {
      error.message = err.response.data.Message;
    }

    // console.log('interceptors.response.use.err:', err);
    console.log('interceptors.response.use.err.response.data:', err.response.data);
    console.log('interceptors.response.use.err.error:', error);
    console.log('interceptors.response.use.err.response:', err.response);
    console.log('interceptors.response.use.err.request:', err.request);
    console.log('interceptors.response.use.err.message:', err.message);

    if (err.code == "ECONNABORTED") {
      error.message = "Tempo excedido para a execução desta requisição";
    } else {
      if (!err.response) {
        error.message =
          "Erro geral de rede!!! Verifique sua conexão com a internet";
      } else {
        error.status = err.response.status;
        error.data = err.response.data;
        error.headers = err.response.headers;
        error.response = err.response;
        switch (error.status) {
           case 400:
             if (err.response.data.User) {
               error.message = "Necessário informar o usuário";
               error.variant = "info";
             } else {
               if (err.response.data.Password) {
                 error.message = "Necessário informar a senha";
                 error.variant = "info";
                
               } else {
                 if (err.response.data.Error) {
                   error.message = err.response.data.Error;
                   error.variant = "warning";
                 } else {
                   if (err.response.data.data) {
                     error.message = err.response.data.data[0];
                     error.variant = "warning";
                   } else {
                     if (err.response.data.Message) {
                       error.message = err.response.data.Message;
                       error.variant = "warning";
                     } else {
                       error.message = err.response.data;
                       error.variant = "warning";
                     }
                   }
                 }
               }
             }
             break;
          case 401:
            if (err.response.data) {
              error.message = err.response.data;
            } else {
              error.message = "Erro na autenticação, verifique usuário e senha";
              ApiService.loginObserver.notify(false);
            }
            error.variant = "info";
            if (error.route !== "Authentication") {
              router.push({ name: "Unauthorized" });
            }
            break;
          case 403:
            if (err.response.data) {
              error.message = err.response.data;
            } else {
              error.message = "Usuário não tem permissão para executar essa requisição";
              ApiService.loginObserver.notify(false);
            }
            error.variant = "info";
            break;
          case 404:
            // console.log("router:", router.currentRoute);
            error.message = `Endpoint inexistente [${error.response.config.url}]`;
            error.variant = "danger";
            break;
          default:
            error.message = "Ocorreu um erro na requisição";
            error.variant = "danger";
        }

        if (err.config.headers["Doloading"]) {
          ApiService.loadObserver.notify(false);
        };
        // salvo o erro no IndexDB
        let errorDB = [{
          status: error.status,
          data: error.data,
          message: error.message,
          config: {
            path: error.response.config.url,
            method: error.response.config.method,
            params: error.response.config.params,
          },

          route: {
            path: error.route.path,
            params: error.route.params,
            query: error.route.query,
          },
          timestamp: error.timestamp
        }];

        // le os erros existentes
        ApiService.getLocalDBDocument("pageError")
          .then((doc) => {
            if (doc && doc.data) {
              doc.data.push(errorDB);
              errorDB = doc.data;
            }
            // console.log('errorDB:', errorDB);
            ApiService.setLocalDBDocument({ data: errorDB }, "pageError");
          });
      }
    }
    
    // console.log('ApiService.intercept.response.err:', err.config.headers["Doloading"]);
    if (err.config.headers["Doloading"]) {
      ApiService.loadObserver.notify(false);
    };
    // console.log("error:", error);
    ApiService.errorObserver.notify(error);

    // loga o erro e guarda no IndexDB...
    // console.log('APIService.error:', error);

    return Promise.reject(err);
  }
);
// FIM - Interceptors

export default ApiService;
